import React from "react";
import { LightbulbIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { challenges } from "../../data/comparison";
export function Challenges() {
  return <section className="bg-mist px-4 py-16 sm:px-6 sm:py-20" data-id="element-163" data-mp="2cy5w74sinoag">
      <div className="mx-auto max-w-5xl" data-id="element-164" data-mp="2hwz148tqm6z0">
        <SectionHeading kicker="Does any of this sound familiar?" title="6 challenges this system was designed to help you address" data-id="element-165" data-mp="2hvxqu6kjpoic" />

        <ol className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-166" data-mp="27zulkrued9r6">
          {challenges.map((c, i) => <li key={c.title} className="flex flex-col rounded-3xl bg-white p-5 sm:p-6" data-id="element-167" data-mp="1u0lag6l1t5u2" data-mpi={i}>
              <div className="flex items-start gap-3" data-id="element-168" data-mp="1yyeg8yifvxtt">
                <span className="font-display text-4xl font-extrabold leading-none text-brand" data-id="element-169" data-mp="1z10l2qdy3z8c">{i + 1}</span>
                <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-170" data-mp="3oc00kohz17ac">
                  {c.title}
                </h3>
              </div>
              <div className="mt-3 space-y-2 leading-relaxed text-ink-muted" data-id="element-171" data-mp="xauiu667f3ec">
                {c.body.map(p => <p key={p} data-id="element-172" data-mp="t8pqdarhscta">{p}</p>)}
              </div>
              <div className="mt-auto pt-5" data-id="element-173" data-mp="171p5hbnd450b">
                <div className="rounded-2xl bg-navy-900 p-4 text-white" data-id="element-174" data-mp="1234253ctd57n">
                  <p className="flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.14em] text-gold" data-id="element-175" data-mp="12573gjjf2kro">
                    <LightbulbIcon className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="aby0gihg2zg9" />
                    The Blueprint solution
                  </p>
                  <p className="mt-1.5 font-semibold leading-snug" data-id="element-177" data-mp="ocquz37qxujd">{c.solution}</p>
                </div>
              </div>
            </li>)}
        </ol>

        <CTAButton className="mt-10" label="Solve these challenges today" note="Instant digital access · $27 USD" data-id="element-178" data-mp="1zqw5kf2gt2no" />
      </div>
    </section>;
}